import React, { useContext, useState } from 'react';
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from '../../firebase.config';
import { UserContext } from '../../App';
import { useHistory, useLocation } from 'react-router';
import './Login.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGoogle, faFacebook, faGithub} from '@fortawesome/free-brands-svg-icons'



firebase.initializeApp(firebaseConfig);
const LogIn = () => {
const [user, setUser] = useState({
    isSignIn: false,
    name: '',
    email: '',
    photo: ''
})


const [logInUser, setLogInUser] = useContext(UserContext);
const history = useHistory();
const location = useLocation();
const { from } = location.state || { from: { pathname: "/" } };

const provider = new firebase.auth.GoogleAuthProvider();
const githubprovider = new firebase.auth.GithubAuthProvider();const handleSignIn = () => {
    firebase.auth().signInWithPopup(provider)
    .then(res => {
        console.log(res.user)

    const {displayName, photoUrl, email} = res.user;
    const signInUSer ={
        isSignIn: true,
    name: displayName,
    email:email,
    photo: photoUrl,
    }
    setUser(signInUSer);

    setLogInUser(signInUSer);
    storeAuthToken();
    console.log(displayName, photoUrl, email)
    })
    .catch(err => {
        console.log(err);
        console.log(err.message);
    })
}


const handleGithubSignIn = () => {
    firebase
  .auth()
  .signInWithPopup(githubprovider)
  .then((result) => {
    var credential = result.credential;
    var token = credential.accessToken;
    var user = result.user;
    const {displayName, photoUrl, email} = result.user;
    const signInUSer ={
        isSignIn: true,
    name: displayName,
    email:email,
    photo: photoUrl,
    }
    setUser(signInUSer);

    setLogInUser(signInUSer);
    storeAuthToken();
  }).catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;
    var email = error.email;
    var credential = error.credential;
  });
}
const storeAuthToken = () => {
    firebase.auth().currentUser.getIdToken( true)
      .then(function (idToken) {
        sessionStorage.setItem('token', idToken);
        history.replace(from);
      }).catch(function (error) {
        // Handle error
      });
  }

require('dotenv').config()


    return (
        <div id="login">
            <ul className="loginPage">
                <li className="login" onClick={handleSignIn}><FontAwesomeIcon icon={faGoogle} />  Click To Google Login</li>
                <li className="login" onClick={handleGithubSignIn}><FontAwesomeIcon icon={faGithub} />  Click To Github Login</li>
            </ul>
        </div>
    );
};

export default LogIn;
